export const CARRIER = {
  ALL: 'all',
  APP: 'app',
  MOBILE_WEB: 'mobile-web',
  DESKTOP_WEB: 'desktop-web',
  UNKNOWN: 'unknown'
}

export const CARRIER_MAP = {
  [CARRIER.ALL]: '全部',
  [CARRIER.APP]: 'APP',
  [CARRIER.MOBILE_WEB]: 'Mobile Web',
  [CARRIER.DESKTOP_WEB]: 'Desktop Web',
  [CARRIER.UNKNOWN]: '其他'
}

export const CARRIER_OPTIONS = [
  {
    label: CARRIER_MAP[CARRIER.ALL],
    value: CARRIER.ALL
  },
  {
    label: CARRIER_MAP[CARRIER.APP],
    value: CARRIER.APP
  },
  {
    label: CARRIER_MAP[CARRIER.MOBILE_WEB],
    value: CARRIER.MOBILE_WEB
  },
  {
    label: CARRIER_MAP[CARRIER.DESKTOP_WEB],
    value: CARRIER.DESKTOP_WEB
  }
]

export const CARRIER_FULL_OPTIONS = [
  {
    label: CARRIER_MAP[CARRIER.ALL],
    value: CARRIER.ALL
  },
  {
    label: CARRIER_MAP[CARRIER.APP],
    value: CARRIER.APP
  },
  {
    label: CARRIER_MAP[CARRIER.MOBILE_WEB],
    value: CARRIER.MOBILE_WEB
  },
  {
    label: CARRIER_MAP[CARRIER.DESKTOP_WEB],
    value: CARRIER.DESKTOP_WEB
  },
  {
    label: CARRIER_MAP[CARRIER.UNKNOWN],
    value: CARRIER.UNKNOWN
  }
]
